import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

/**
 * Hook to fetch the current user's details from the S2 API and check
 * whether they are active staff.
 */
export function useMyDetails() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data, isPending, isError } = useQuery({
		queryKey: ["myDetails"],
		queryFn: () => callPymbleApi(instance, "GET", "my/details/"),
		enabled: isAuthenticated,
	});

	const hasAdminAccess = data?.active?.staff === true;

	return {
		isLoading: isPending,
		isError,
		hasAdminAccess,
		/* The caller's own ContactPersonal `_id` — the id space the publishing
		   stamps use, so a screen can tell its own submissions from everyone
		   else's without asking the server who it is a second time. */
		contactId: (data?._id as string | undefined) ?? undefined,
	};
}
